export const environment = {
  environment: 'production',
  sentryDsn:
    'https://6bdd36f2fd8928abae09535796eb7cee@o4512028261220352.ingest.us.sentry.io/4512028286844928',
  gaMeasurementId: 'G-VXVYBQGYKM',
      mapboxAccessToken: 'pk.eyJ1IjoidGR1c2EiLCJhIjoiY21ydHA4aW1jMDVjZDJ3b3VhMHZtcXJmciJ9.Gc4fYX0W2PgvAQUSSJK2zA',
};
